import React from 'react';
import hactivateData from '../../data/hactivate.json';
import certStarImg from './cert-star.svg';
import skillHatImg from './skill-hat.svg';
import CourseDetail from '../CourseDetail';

class Certificate extends React.Component {

  render() {

    console.log(this.props);

    const courseId = this.props.match.params.courseid;

    const styles = {
      backgroundColor: '#DBFD0C',
      position: 'relative',
      maxWidth: '320px',
      width: '80vw',
      margin: '0 auto',
      padding: '1em'
    };

    const h1Style = {
      width: "4.7em",
      fontSize: "66px",
      marginTop: "0.7em",
      marginBottom: "0",
      lineHeight: "0.9em",
    };

    const h2Style = {
      display: "inline-block",
      color: "#B3B3B3",
      backgroundColor: "#252525",
      fontSize: "35px",
      marginTop: "0.1em",
      marginBottom: "0",
    };

    const headerContainer = {
      marginTop: '2em'
    };

    return (
      <div style={styles}>
        <div style={headerContainer}>
          <p class="gigsHeading" style={h1Style}>PWNAGE!!!</p>
          <p style={h2Style}>CONGRATS YOU'VE</p><br/>
          <p style={h2Style}>LEVELLED UP...</p>
        </div>
        <div className="certificate" >
          <div className="certificateLine">
            <div class="certImg">
              <img src={skillHatImg} alt=""/>
            </div>
            <div className="certificateInfo">
              { hactivateData.courses[courseId].courseTitle}
            </div>
          </div>
          <div className="certificateLine">
            <div class="certImg">
              <img src={certStarImg} alt=""/>
            </div>
            <div className="certificateInfo">
              { hactivateData.courses[courseId].skills}
            </div>
          </div>
        </div>
        <div>
          <a className="beginCourse"href='/gigs'>
            FIND GIGS >
          </a>
        </div>
      </div>
    );
  }
}

export default Certificate;



// WEBPACK FOOTER //
// ./src/components/Certificate/index.js